// MessageProgressBar.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

export const MessageProgressBar = ({ max, value, color }) => {
  const scaleX = (value / max).toFixed(9) * 100;
  const hasTransition = scaleX < 99 && scaleX > 1;
  return (
    <StyledMessageProgressBar>
      <ProgressValue
        scaleX={scaleX}
        hasTransition={hasTransition}
        color={color}
      />
    </StyledMessageProgressBar>
  );
};

MessageProgressBar.propTypes = {
  max: PropTypes.number,
  value: PropTypes.number,
  color: PropTypes.string,
};

MessageProgressBar.defaultProps = {
  max: 0,
  value: 0,
  color: 'rgba(255, 255, 255, 0.8)',
};

const StyledMessageProgressBar = styled.div`
  width: 100%;
  height: 2px;
  border-radius: 2px;
  background-color: rgba(255, 255, 255, 0.2);
  overflow: hidden;
`;

const ProgressValue = styled.div.attrs(props => ({
  style: {
    width: `${props.scaleX}%`,
    backgroundColor: props.color,
  },
}))`
  height: 100%;
  border-radius: 2px;
  transform-origin: 0% 0%;
  will-change: width;
  ${({ hasTransition }) => (hasTransition ? transition : null)}
`;

const transition = css`
  transition: width 0.1s linear;
`;

export default MessageProgressBar;
